/*
 * @Author: Teemo Ding
 * @Date: 2021-04-20 15:40:42
 * @LastEditTime: 2021-07-07 15:05:20
 * @LastEditors: Teemo Ding
 * @Description: In User Settings Edit
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductAlias/EditPage/ThumbnailImage/index.tsx
 */

import { Checkbox } from '@/src/components/Antd';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import React from 'react';
import { useDispatch } from 'react-redux';
import DragNDropColumns from 'src/components/DragNDropColumns';
import DraggableImageDisplay from 'src/components/DragRowDisplay/Image';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';

import { EnumLinkType } from '@/src/types/common/linkType';

import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getThumbnailImage,
  onCollapseOpen,
  onErrorChange,
  onThumbnailImageOnChange,
  onThumbnailImageOnSort,
  onThumbnailImageSameAsOriginalOnChange,
} from '../slice';

import { validateThumbnailImage } from '../tools';

import { useI18n } from 'src/hooks/useRouterChange';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';
import styles from './style.module.less';
const ThumbnailImage = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    data,
    specificError = {},
    isOnPrimaryLanguage,
    disabled,
    hideEdit,
  } = props;

  const { sameAsOriginal = false, linkModules = [] } = data || {};

  const _d = useDispatch();
  const renderContent = (data, index) => {
    const { draggableId, title, subtitle, linkImage } = data || {};
    const imageErrorArray = specificError[`${draggableId}_imageError`] || [];
    return (
      <Section key={draggableId} className={styles.section}>
        <DraggableImageDisplay
          title={title}
          subtitle={subtitle}
          imgOnChange={(img) =>
            handleOnChange(index, {
              linkImage: img,
              linkType: EnumLinkType.None,
              draggableId,
            })
          }
          linkImage={linkImage}
          error={imageErrorArray}
          disabled={disabled}
          hideEdit={hideEdit}
        />
      </Section>
    );
  };

  const handleOnChange = (index, data) => {
    _d(onThumbnailImageOnChange({ index, data }));
  };
  const sameAsOriginalOnChange = (checked) => {
    _d(onThumbnailImageSameAsOriginalOnChange({ sameAsOriginal: checked }));
  };
  const onThumbnailImageSort = (obj) => {
    const { data } = obj;
    const { newIndex, oldIndex } = data || {};
    _d(onThumbnailImageOnSort({ from: oldIndex, to: newIndex }));
  };

  return linkModules.length > 0 ? (
    <div>
      <Section bottomBorder>
        <div className={styles.enabledContainer}>
          <Checkbox
            checked={sameAsOriginal}
            disabled={disabled}
            onChange={(checked) => sameAsOriginalOnChange(checked)}>
            {getI18n('salesChannelProductAlias.editPage.sameasoriginal')}
          </Checkbox>
        </div>
      </Section>
      {!sameAsOriginal ? (
        isOnPrimaryLanguage ? (
          <DragNDropColumns
            hideTitle
            childGenerate={renderContent}
            data={linkModules || []}
            droppableId={'thumbnailImage'}
            onSort={onThumbnailImageSort}
            hideAdd
            onAdd={() => {
              console.log('onAdd');
            }}
            addText=''
            hideDrag={disabled}
          />
        ) : (
          <div>
            {linkModules.map((data, index) => renderContent(data, index))}
          </div>
        )
      ) : (
        ''
      )}
    </div>
  ) : (
    ''
  );
};

export default ErrorProcessingHOC(ThumbnailImage, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.thumbnailImage,
  getContent: getThumbnailImage,
  title: getI18nFromGeneral('general.hOCTitle.variantThumbnailImage'),
  validation: validateThumbnailImage,
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
});
